import { Fragment, useEffect, useState } from 'react'
import Link from 'next/link'
import Box from '@mui/material/Box'
import Icon from 'src/@core/components/icon'
import { Accordion, AccordionDetails, AccordionSummary, InputAdornment, Stack, Typography } from '@mui/material'
import CustomTextField from '@/src/@core/components/mui/text-field'
import { useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@/src/store'
import { FaqHelpListData } from '@/src/context/enum'
import { Resto365FAQList } from '@/src/types/apps/faq'
import { useDispatch } from 'react-redux'
import { gygResto365FAQList } from '@/src/store/apps/resto365Faq'
import { filter, some } from 'lodash'

const GygDrawer = () => {
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    dispatch(gygResto365FAQList())
  }, [dispatch])

  const { pending, resto365Faqs } = useSelector((state: RootState) => state.resto365FaqsData)

  const [filteredAllFaq, setFilteredAllFaq] = useState<Resto365FAQList[]>([])

  const handleSearch = (val: string) => {
    const searchValue = searchFilter(val)
    setFilteredAllFaq(searchValue)
  }

  const searchFilter = (val: string) => {
    if (val.length > 0) {
      return filter(resto365Faqs, store =>
        some(store, value => (value?.toString().toLowerCase() ?? '').includes(val.toLowerCase()))
      )
    }

    return resto365Faqs
  }

  useEffect(() => {
    if (!pending) {
      setFilteredAllFaq(resto365Faqs)
    }
  }, [pending, resto365Faqs])

  return (
    <Fragment>
      <Box>
        <Box sx={{ padding: '20px', backgroundColor: '#E0E0E0' }} role='presentation'>
          <h3 style={{ marginBottom: '10px', textAlign: 'center', fontSize: '24px', color: '#171717' }}>Help</h3>
          <p style={{ textAlign: 'center', fontSize: '14px', color: '#171717' }}>
            Search or choose a category to find the help you need
          </p>
          <CustomTextField
            fullWidth
            color='secondary'
            placeholder='Search'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <Icon icon='iconamoon:search-bold' />
                </InputAdornment>
              )
            }}
            onChange={e => handleSearch(e.target.value)}
            sx={{
              display: 'inline-flex'
            }}
          />
        </Box>
        <Box role='presentation'>
          {FaqHelpListData.map((helplist: any, index: number) => {
            return (
              <Fragment key={index}>
                <Accordion sx={{ my: 2 }}>
                  <AccordionSummary expandIcon={<Icon icon='lets-icons:expand-down' />} sx={{ m: 0 }}>
                    <Stack direction={'row'} gap={5}>
                      <Box height={38} sx={{ backgroundColor: '#FFECA9', padding: '8px', borderRadius: '4px' }}>
                        <Icon icon={helplist.icon} fontSize={22} />
                      </Box>
                      <Typography variant='h6' margin={2}>
                        {helplist.value}
                      </Typography>
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails>
                    <>
                      {filteredAllFaq &&
                        filteredAllFaq.map((faq: any, index: number) => {
                          if (faq.category === helplist.name) {
                            return (
                              <Fragment key={index}>
                                <Typography textAlign={'left'}>
                                  <Link href={faq.documentUrl} target='_blank'>
                                    <Stack direction={'row'} margin={5} gap={3}>
                                      <Typography variant='h6'>
                                        {faq.title.length > 60 ? `${faq.title.substring(0, 60)}...` : faq.title}
                                      </Typography>
                                      <Icon icon='material-symbols:open-in-new' fontSize={22} display={'inline-flex'} />
                                    </Stack>
                                  </Link>
                                </Typography>
                              </Fragment>
                            )
                          }
                        })}
                    </>
                  </AccordionDetails>
                </Accordion>
              </Fragment>
            )
          })}
        </Box>
      </Box>
    </Fragment>
  )
}

export default GygDrawer
